// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".creator-filter-container__CHbxB93N{padding:12px}.creator-filter__UKHtsgvT{--select-trigger-padding:0;margin-top:8px;width:100%}.creator-filter-select-trigger__svR1i_Fw .trigger-label__pOZQFYwg{display:flex;line-height:22px;white-space:pre;width:100%}.creator-filter-select-trigger__svR1i_Fw .trigger-label-suffix__GJOUwgPd{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.creator-filter-select-trigger__svR1i_Fw .trigger-button__oT79EpJ7{--button-justify-content:left;height:40px;width:100%}.creator-filter-select-trigger__svR1i_Fw .trigger-users__HvodmitC{margin:0 4px}.creator-filter-select-trigger__svR1i_Fw .trigger-icon__caQD7xY6{margin-right:4px}.creator-filter-select-trigger__svR1i_Fw .trigger-caret__fpbrzUd4{margin-left:auto}.creator-filter-label__LS6UjYyd{color:var(--secondary-text-color);font-size:12px;font-wight:500}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"creatorFilterContainer": "creator-filter-container__CHbxB93N",
	"creatorFilter": "creator-filter__UKHtsgvT",
	"creatorFilterSelectTrigger": "creator-filter-select-trigger__svR1i_Fw",
	"triggerLabel": "trigger-label__pOZQFYwg",
	"triggerLabelSuffix": "trigger-label-suffix__GJOUwgPd",
	"triggerButton": "trigger-button__oT79EpJ7",
	"triggerUsers": "trigger-users__HvodmitC",
	"triggerIcon": "trigger-icon__caQD7xY6",
	"triggerCaret": "trigger-caret__fpbrzUd4",
	"creatorFilterLabel": "creator-filter-label__LS6UjYyd"
};

/*** EXPORTS FROM exports-loader ***/
export default ___CSS_LOADER_EXPORT___.toString();
